import { forwardRef, useState } from 'react'
import { Button } from '../ui/button'

import { FaEye, FaEyeSlash } from 'react-icons/fa'

import type { FieldError } from 'react-hook-form'
import { TextInput } from '../inputs/text-input'
import type { InputProps } from '../ui/input'
import { Show } from '../show'

type PasswordInputProps = InputProps & {
  error?: FieldError
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ error, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
      <div className="w-full">
        <div className="relative flex items-end flex-col">
          <div className="w-full flex">
            <TextInput
              ref={ref}
              type={showPassword ? 'text' : 'password'}
              error={error}
              {...props}
            />
            <Show when={!error}>
              <Button
                type="button"
                size="icon"
                className="absolute bg-transparent shadow-none text-black border-none right-1 p-0"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </Button>
            </Show>
          </div>
        </div>
      </div>
    )
  },
)
PasswordInput.displayName = 'PasswordInput'
